import { isNativeWebView } from "@/hooks/useNativeBridge";

export function isAndroidDevice(): boolean {
  return /Android/i.test(navigator.userAgent);
}

export function isMobileDevice(): boolean {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

export function shouldShowWebLoginUI(): boolean {
  return !isNativeWebView();
}
